export interface IdentityVerificationSummary {
  method: IdentityVerificationMethod;
  status: IdentityVerificationStatus;
  lastErrorMessage: string;
  errors: Record<string, string[]>;
}

export interface IdentityVerificationInfo {
  baseUrl: string;
}

export enum IdentityVerificationMethod {
  IDVerse = 'id-verse',
  KBA = 'kba'
}

export const IdentityVerificationMethodLabel = new Map<string, string>([
  [IdentityVerificationMethod.IDVerse, "IDVerse"],
  [IdentityVerificationMethod.KBA, "KBA"],
]);

export enum IdentityVerificationStatus {
  None = 'none',
  Pending = 'pending',
  Success = 'success',
  Failed = 'failed',
  Syncing = 'syncing'
}

export const IdentityVerificationStatusLabel = new Map<string, string>([
  [IdentityVerificationStatus.None, "None"],
  [IdentityVerificationStatus.Pending, "Pending Customer"],
  [IdentityVerificationStatus.Success, "Verified"],
  [IdentityVerificationStatus.Failed, "Failed"],
  [IdentityVerificationStatus.Syncing, "Syncing"],
]);

export enum IdentityVerificationAction {
  ShowError = 'show-error',
  Verify = 'verify',
  Skip = 'skip',
}

export interface IdVerseStateData {
  status: IdentityVerificationStatus;
  onFailedAction: IdVerseFailedAction;
  verificationUrl: string;
}

export interface StoreVerificationData {
  verificationUrl: string;
}

export enum IdVerseFailedAction {
  ShowError = 'show-error',
  TryAgainOnError = 'try-again-on-error',
  TryAgainOnExpired = 'try-again-on-expired',
  ShowErrorOnExpired = 'show-error-on-expired',
  SwitchToKba = 'switch-to-kba',
}

export interface UpdateIdentityVerificationPayload {
  method: IdentityVerificationMethod;
  status: IdentityVerificationStatus;
  customerId: number;
}

export interface StartNewIdVerseResponse {
  verificationUrl: string;
}
